module.exports = __webpack_public_path__ + "img/Ssa3.6e003369.jpg";